module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control button has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px;   z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append(";\">\r\n\r\n    <div class=\"size-handle-top\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\" style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n\r\n    <div class=\"pf-control-core pf-selectable\" style=\"height: ")
    ; __append(escapeFn( u.extractNum( height ) ))
    ; __append("px; width: ")
    ; __append(escapeFn( u.extractNum( width ) ))
    ; __append("px;\r\n            font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append("; font-size: ")
    ; __append(escapeFn( fontSize ))
    ; __append("px;\r\n                -webkit-border-radius: 0px;\r\n                -moz-border-radius: 0px;\r\n            border: ")
    ; __append(escapeFn(borderSize))
    ; __append("px ")
    ; __append(escapeFn(borderStyle))
    ; __append(" ")
    ; __append(escapeFn(borderColor))
    ; __append(";\r\n            border-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px;\r\n            background: ")
    ; __append(escapeFn(backgroundColor))
    ; __append(";\r\n            font-style: ")
    ; __append(escapeFn( textStyle ))
    ; __append("; font-weight: ")
    ; __append(escapeFn( textWeight ))
    ; __append("; color: ")
    ; __append(escapeFn( styleColorText ))
    ; __append("\">\r\n\r\n        ")
    ;  switch (type){
        case "text":"daysAgo";"weeksAgo";"monthsAgo";"yearsAgo";"minutesAgo";"hoursAgo"
        
    ; __append("\r\n        <div class=\"input-group\" style=\"height: 100%;\">\r\n            <span></span>\r\n            <span class=\"filter-input-icon\"><img draggable=\"false\" src=\"")
    ; __append( require('common/icons/gray_magnifier.png') )
    ; __append("\" width=\"16px\" height=\"16px;\"\r\n                style=\"margin-top: 0px; vertical-align: middle;\" /></span>\r\n        </div>\r\n        ")
    ;  break;
        case "number":
        
    ; __append("\r\n        <div class=\"input-group\" style=\"height: 100%;\">\r\n            <span></span>\r\n            <span class=\"filter-input-icon\"><img draggable=\"false\" src=\"")
    ; __append( require('common/icons/gray_magnifier.png') )
    ; __append("\" width=\"16px\" height=\"16px;\"\r\n                style=\"margin-top: 0px; vertical-align: middle;\" /></span>\r\n        </div>\r\n        ")
    ; 
            break;
        case "day":
        
    ; __append("\r\n        <div class=\"input-group\" style=\"height: 100%;\">\r\n            <span></span>\r\n            <span class=\"filter-input-icon\"> <img draggable=\"false\" src=\"")
    ; __append( require('common/icons/calendar.gif') )
    ; __append("\" width=\"16px\" height=\"16px;\"\r\n                style=\"margin-top: 0px; vertical-align: middle;\" /></span>\r\n            <span class=\"filter-input-icon\"><img draggable=\"false\" src=\"")
    ; __append( require('common/icons/gray_magnifier.png') )
    ; __append("\" width=\"16px\" height=\"16px;\"\r\n                style=\"margin-top: 0px; vertical-align: middle;\" /></span>\r\n        </div>\r\n        ")
    ; 
            break;
        case "month":
        
    ; __append("\r\n        <div class=\"input-group\" style=\"height: 100%;\">\r\n            <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                    <select style=\"background: ")
    ; __append(escapeFn( backgroundColor))
    ; __append("; font-size: ")
    ; __append(escapeFn( fontSize))
    ; __append("px; height: ")
    ; __append(escapeFn( height))
    ; __append("px\">\r\n                        <option value=\"Jan\" selected>Jan</option>\r\n                    </select>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                    <select style=\"background: ")
    ; __append(escapeFn( backgroundColor))
    ; __append("; font-size: ")
    ; __append(escapeFn( fontSize))
    ; __append("px; height: ")
    ; __append(escapeFn( height))
    ; __append("px\">\r\n                        <option value=\"2006\" selected>2006</option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n            <span class=\"filter-input-icon\"><img draggable=\"false\" src=\"")
    ; __append( require('common/icons/gray_magnifier.png') )
    ; __append("\" width=\"16px\" height=\"16px;\"\r\n                style=\"margin-top: 0px; vertical-align: middle;\" /></span>\r\n        </div>\r\n        ")
    ; 
            break;
        case "week":
        
    ; __append("\r\n        <div class=\"input-group\" style=\"height: 100%;\">\r\n            <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                    <select style=\"background: ")
    ; __append(escapeFn( backgroundColor))
    ; __append("; font-size: ")
    ; __append(escapeFn( fontSize))
    ; __append("px; height: ")
    ; __append(escapeFn( height))
    ; __append("px\">\r\n                        <option value=\"1\" selected>1</option>\r\n                    </select>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                    <select style=\"background: ")
    ; __append(escapeFn( backgroundColor))
    ; __append("; font-size: ")
    ; __append(escapeFn( fontSize))
    ; __append("px; height: ")
    ; __append(escapeFn( height))
    ; __append("px\">\r\n                        <option value=\"2006\" selected>2006</option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n            <span class=\"filter-input-icon\"><img draggable=\"false\" src=\"")
    ; __append( require('common/icons/gray_magnifier.png') )
    ; __append("\" width=\"16px\" height=\"16px;\"\r\n                style=\"margin-top: 0px; vertical-align: middle;\" /></span>\r\n        </div>\r\n        ")
    ; 
            break;
        case "year":
        
    ; __append("\r\n        <div class=\"input-group\" style=\"height: 100%;\">\r\n            <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                    <select style=\"background: ")
    ; __append(escapeFn( backgroundColor))
    ; __append("; font-size: ")
    ; __append(escapeFn( fontSize))
    ; __append("px; height: ")
    ; __append(escapeFn( height))
    ; __append("px\">\r\n                        <option value=\"2006\" selected>2006</option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n            <span class=\"filter-input-icon\"><img draggable=\"false\" src=\"")
    ; __append( require('common/icons/gray_magnifier.png') )
    ; __append("\" width=\"16px\" height=\"16px;\"\r\n                style=\"margin-top: 0px; vertical-align: middle;\" /></span>\r\n        </div>\r\n        ")
    ; 
            break;
        case "time":
        
    ; __append("\r\n        <div class=\"input-group\" style=\"height: 100%;\">\r\n            <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                    <span>18:00</span>\r\n                </div>\r\n            </div>\r\n            <span class=\"filter-input-icon\"><span class=\"timeEntry_control\" style=\"display: inline-block; background: url('")
    ; __append( require('editor/icons/spinnerUpDownnew.png') )
    ; __append("') 0 0 no-repeat; width: 15px; height: 24px;\" title=\"Increment\"></span>\r\n        </span>\r\n            <span class=\"filter-input-icon\"><img draggable=\"false\" src=\"")
    ; __append( require('common/icons/gray_magnifier.png') )
    ; __append("\" width=\"16px\" height=\"16px;\"\r\n                style=\"margin-top: -10px; vertical-align: middle;\" /></span>\r\n        </div>\r\n        ")
    ; 
            break;
        } 
    ; __append("\r\n    </div>\r\n    <div class=\"size-handle-right\" style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px;\"></div>\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}